import { render, staticRenderFns } from "./ConfiguratorStart.vue?vue&type=template&id=f47e398e&scoped=true&"
import script from "./ConfiguratorStart.vue?vue&type=script&lang=js&"
export * from "./ConfiguratorStart.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguratorStart.vue?vue&type=style&index=0&id=f47e398e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47e398e",
  null
  
)

export default component.exports